import type { HTMLAttributes } from 'react';
import { cn } from '@skupreme/shared/ui';

/* The page's title bar, 48px tall, over the scrolling content. */
export function StyledHeader({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <header
      {...rest}
      className={cn(
        'sk:flex sk:h-12 sk:shrink-0 sk:items-center sk:justify-between sk:px-4',
        className,
      )}
    />
  );
}
